import React from 'react';

interface Props {
  children: React.ReactNode;
}
interface State {
  hasError: boolean;
}

/**
 * Isola a camada de comentários: qualquer exceção dentro dela renderiza `null`
 * em vez de derrubar o protótipo inteiro.
 */
export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: unknown) {
    // eslint-disable-next-line no-console
    console.error('[comments] erro isolado pela ErrorBoundary:', error);
  }

  render() {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}
